import { render } from "./GrSort.vue?vue&type=template&id=557b721d&scoped=true"
import script from "./GrSort.vue?vue&type=script&lang=js"
export * from "./GrSort.vue?vue&type=script&lang=js"

import "./GrSort.vue?vue&type=style&index=0&id=557b721d&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557b721d"]])

export default __exports__